import React from 'react';
import { Fingerprint, ScanFace, CheckCircle, XCircle } from 'lucide-react';
interface BiometricStatusIconProps {
  type: 'fingerprint' | 'face';
  isEnrolled: boolean;
}
export function BiometricStatusIcon({
  type,
  isEnrolled
}: BiometricStatusIconProps) {
  const Icon = type === 'fingerprint' ? Fingerprint : ScanFace;
  return <div className="relative inline-flex" data-id="element-20">
      <div className={`p-1.5 rounded-md ${isEnrolled ? 'bg-slate-700 text-slate-300' : 'bg-slate-800 text-slate-600'}`} data-id="element-21">
        <Icon size={16} data-id="element-22" />
      </div>
      <div className="absolute -top-1 -right-1 bg-slate-900 rounded-full p-0.5" data-id="element-23">
        {isEnrolled ? <CheckCircle size={10} className="text-green-500 fill-green-500/20" data-id="element-24" /> : <XCircle size={10} className="text-slate-600 fill-slate-600/20" data-id="element-25" />}
      </div>
    </div>;
}